module.exports = {
  mode: 'development',
  disableSecurity: true,
  googleApiKey: 'AIzaSyBixcFsmrOmqHGAvxyWD4kwC4CGc0l-AtY',
  wsApiUrl: 'https://wsapi.staging.wannasport.com/api',
  googleLoginClientId: '1069111212197-59ovsv7rp1dnskgeksh9leu5svvuvnvb.apps.googleusercontent.com',
  intercomAppId: '',
  adyen: {
    domain: 'ca-test.adyen.com'
  }
};